import { AppLayout } from "../shared";
import MasterOrgAddAdvertisement from "../MasterOrg/MasterOrgAddAdvertisement";

const MasterOrgAddAdvertisement_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <MasterOrgAddAdvertisement props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default MasterOrgAddAdvertisement_layout;
